import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";

import LoginLogo from '../login-screen/login-logo'
import InputFormContainer from './input-form-container'


const styles = theme => ({
	root: {
		overflowY: "auto",
		overflowScrolling: "touch",
		WebkitOverflowScrolling: "touch",
		overscrollBehavior: "none",
		overflowX: "hidden",
		flexGrow: 1,
		"& > div":{
			width: "70%",
			paddingTop: "20px",
			margin: '1vh auto',
		}
	}
});


function LoginEmailScreen(props) {
	const { classes } = props;

	return (
		<div className={ classes.root }>
			<div>
				<LoginLogo/>
				<InputFormContainer push={props.push}/>
			</div>
		</div>
	)
}

LoginEmailScreen.propTypes = {
	push: PropTypes.func.isRequired,

	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LoginEmailScreen);